import { capitalizeFirstLetter } from "../../helpers/StringHelper";
import { httpGet, httpPost } from "../Backend";

export class NonSensitiveDataApi {

    private root = 'api/nonSensitiveData';

    public async getNotes(request: IGetNotesRequest) {
        const url = `${this.root}/notes`;
        const urlSearchParams = new URLSearchParams();
        urlSearchParams.append('id', request.id);
        urlSearchParams.append('entityName',request.entityName);
        return await httpGet(`${url}?${urlSearchParams.toString()}`);
    }

    public async updateNotes(request: IUpdateNotesRequest){
        const url = `${this.root}/updateNotes`;
        return await httpPost(url, request)
    }
}

export interface IGetNotesRequest {
    id: string,
    entityName: string,
    dataTarget: string,
}

export interface IUpdateNotesRequest {
    id: string,
    entityName: string,
    dataTarget: string,
    notes:string
}